import { render, staticRenderFns } from "./carouselDetail.vue?vue&type=template&id=9a70db24&"
import script from "./carouselDetail.vue?vue&type=script&lang=js&"
export * from "./carouselDetail.vue?vue&type=script&lang=js&"
import style0 from "./carouselDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports